<div class="b4a-config-title">
    <h1>{{'tenants.label.clients' | translate}}</h1>
    <button class="b4a-config-btn" [routerLink]="['/tenants/tenant','new']">{{'tenants.label.invest' | translate}}</button>
</div>


<div class="b4a-config-table">
    <div class="b4a-config-header">
        <div class="b4a-config-cell">{{'tenants.label.code' | translate}}</div>
        <div class="b4a-config-cell">{{'tenants.label.name' | translate}}</div>
        <div class="b4a-config-cell center">{{'tenants.label.dev-mode' | translate}}</div>
        <div class="b4a-config-cell center">{{'tenants.label.sales-mode' | translate}}</div>
        <div class="b4a-config-cell center">{{'tenants.label.server-admin' | translate}}</div>
    </div>
    <div class="b4a-config-body">
        <div class="b4a-config-row" *ngFor="let tenant of tenants" [routerLink]="['/tenants/tenant',tenant.id]">
            <div class="b4a-config-cell nowrap">{{tenant.code}}</div>
            <div class="b4a-config-cell">{{tenant.name}}</div>
            <div class="b4a-config-cell center">{{(tenant.dev===true)?'ja':'nein'}}</div>
            <div class="b4a-config-cell center">{{(tenant.sales===true)?'ja':'nein'}}</div>
            <div class="b4a-config-cell center">{{(tenant.admin===true)?'ja':'nein'}}</div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/config/tenants/tenants.component.html